import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Device, isNotUndefined } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DeviceSwappedCurrentActionBarComponent } from './device-swapped-current-action-bar.component';

@Component({
  selector: 'era-device-swapped-current-action-bar',
  templateUrl: './device-swapped-current-action-bar.container.html',
  imports: [DeviceSwappedCurrentActionBarComponent, AsyncPipe],
})
export class DeviceSwappedCurrentActionBarContainerComponent {
  private readonly deviceStore = inject(Store);

  public readonly allowUnavailable$: Observable<boolean>;
  public readonly allowSpare$: Observable<boolean>;
  public readonly device$: Observable<Device>;

  constructor() {
    this.allowUnavailable$ = this.deviceStore.select(DeviceStoreSelectors.selectAllowedToMarkUnavailable);

    this.allowSpare$ = this.deviceStore.select(DeviceStoreSelectors.selectAllowedToMarkAsSpare);

    this.device$ = this.deviceStore
      .select(DeviceStoreSelectors.selectDeviceByCurrentAppleDevice)
      .pipe(filter(isNotUndefined));
  }
}
